import gql from "graphql-tag";

export default gql`
  query SurveyResultQuery($surveyId: ID!) {
    surveyResults(surveyId: $surveyId) {
      id
      userId
      surveyId
      results {
        answers {
          inputName
          value
        }
      }
      user {
        nombre
        apellido
        email
      }
      userDetails {
        documento_de_identidad
        tipo_de_documento
        lugar_de_expedicion
        fecha_de_nacimiento
        lugar_de_nacimiento
        pais_de_nacimiento
        genero
        raza
        grupo_etnico
        estado_civil
        nivel_educativo
        ocupacion
        estrato
        localidad
        departamento
        ciudad
        estado_civil
      }
    }
    surveyById(id: $surveyId) {
      id
      fieldcollection {
        inputName
        answers {
          label
          value
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/fetchResults.js